import React from 'react';

const TechnicianPasswordValidationContext = React.createContext<() => Promise<any>>(undefined);

export default TechnicianPasswordValidationContext;
